import fr from './fr/common.json';

const translations = {
  fr: {
    translation: fr,
  },
};

export default translations;
